var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7279 12.6466L9.57761 18.7322C9.4043 18.9037 9.16924 19 8.92414 19C8.67904 19 8.44399 18.9037 8.27067 18.7322C8.09736 18.5607 8 18.3281 8 18.0856C8 17.8431 8.09736 17.6105 8.27067 17.439L13.7683 12.0008L8.27221 6.56101C8.1864 6.4761 8.11833 6.3753 8.07188 6.26435C8.02544 6.15341 8.00154 6.0345 8.00154 5.91442C8.00154 5.79434 8.02544 5.67543 8.07188 5.56449C8.11833 5.45354 8.1864 5.35274 8.27221 5.26783C8.35803 5.18292 8.4599 5.11556 8.57203 5.06961C8.68415 5.02365 8.80432 5 8.92568 5C9.04704 5 9.16721 5.02365 9.27933 5.06961C9.39146 5.11556 9.49333 5.18292 9.57915 5.26783L15.7294 11.3534C15.8153 11.4383 15.8835 11.5392 15.9299 11.6502C15.9763 11.7612 16.0001 11.8802 16 12.0003C15.9999 12.1205 15.9757 12.2394 15.9291 12.3503C15.8824 12.4612 15.814 12.5619 15.7279 12.6466Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRight);
export default __webpack_public_path__ + "static/media/navRight.cefc16f028931653398a389f00efcb28.svg";
export { ForwardRef as ReactComponent };